<template>
  <router-link :to="location">
    <slot>{{text}}</slot>
  </router-link>
</template>

<script>
export default {
  name: 'RushPlayerLink',

  props: {
    rushPlayerId: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'player'
    },
  },

  computed: {
    /** @returns {Object} */
    location() {
      const id = this.rushPlayerId;

      const loc = {
        name: 'rush_player',
        params: {
          rushId:   id.rushId,
          playerId: id.playerId,
        }
      };

      return loc;
    },

    /** @returns {string} */
    text() {
      const label = this.label;
      const playerIdStr = this.rushPlayerId.playerId.toString();

      if(label.length > 0) {
        return label + ' ' + playerIdStr;
      } else {
        return playerIdStr;
      }
    },
  }
};
</script>
